<template>
    <b-container fluid>
        <b-row>
            <b-col lg="12" sm="12">
                <iq-card>
                    <template v-slot:body>
                        <b-overlay :show="loader">
                            <b-row>
                                <b-col xl="12" lg="12" sm="12">
                                    <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                                        <b-form @submit.prevent="handleSubmit(storeUpdate)" @reset.prevent="reset">
                                            <b-row class="mt-2">
                                                <b-col lg="6" sm="12">
                                                    <ValidationProvider name="Fiscal Year" vid="fiscal_year_id" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="fiscal_year_id"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{$t('globalTrans.fiscal_year')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                v-model="formData.fiscal_year_id"
                                                                id="fiscal_year_id"
                                                                :options="fiscalYearList"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="12">
                                                    <ValidationProvider name="Organization" vid="organization_id" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="organization_id"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{$t('ds_institute_management.organization_name')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                v-model="formData.org_id"
                                                                id="organization"
                                                                :options="orgList"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="12">
                                                    <ValidationProvider name="Circular Memo" vid="circular_id" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="circular_id"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('application_management.circular_memo_no') }} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                v-model="formData.circular_id"
                                                                id="institute_name"
                                                                :options="circularMemoList"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="12">
                                                    <ValidationProvider name="Training Title" vid="training_name_id" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="training_name_id"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('elearning_config.training') }} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                v-model="formData.training_name_id"
                                                                id="training_name_id"
                                                                :options="trainingNameList"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="12">
                                                  <b-spinner v-if="moduleSpinLoader && !id" class="overlay" variant="success" small label="Spinning"></b-spinner>
                                                    <ValidationProvider name="Batch" vid="batch_id" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="batch_id"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('elearning_config.batch') }} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                v-model="formData.batch_id"
                                                                id="batch_id"
                                                                :options="batchList"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="12">
                                                    <b-spinner v-if="trainerSpinLoader && !id" class="overlay" variant="success" small label="Spinning"></b-spinner>
                                                    <ValidationProvider name="Trainer" vid="trainer_id" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="trainer_id"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('trainer_trainee.trainers') }} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                v-model="formData.trainer_id"
                                                                id="trainer_id"
                                                                :options="trainerList"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <table class="table table-bordered">
                                                    <thead style="background-color: #e0e0de">
                                                    <tr style="background-color: #e0e0de">
                                                        <th width="100px">{{ $t('globalTrans.sl_no') }}</th>
                                                        <th>{{$t('tp_management.course')}}</th>
                                                        <th width="100px">{{ $t('globalTrans.action') }}</th>
                                                    </tr>
                                                    </thead>
                                                    <b-tr v-for="(item, index) in formData.details" :key="index">
                                                        <td>{{ $n(index + 1) }}</td>
                                                        <td>
                                                            <keep-alive>
                                                                <ValidationProvider :vid="'name' + index" rules="required" name="Course Name">
                                                                    <div slot-scope="{ valid, errors }">
                                                                        <v-select name="registration_id"
                                                                                  v-model="item.course_id"
                                                                                  label="text"
                                                                                  option-value="value"
                                                                                  option-text="text"
                                                                                  :options=courseSyllabusList
                                                                                  :state="errors[0] ? false : (valid ? true : null)"
                                                                                  :placeholder="$t('globalTrans.select')"
                                                                        />
                                                                        <div class="invalid-feedback d-block">
                                                                            {{ errors[0] }}
                                                                        </div>
                                                                    </div>
                                                                </ValidationProvider>
                                                            </keep-alive>
                                                        </td>
                                                        <b-td style="vertical-align:middle">
                                                            <button v-if="index === formData.details.length - 1" type="button" class="btn btn-sm btn-primary" @click.prevent="addMore(index)">
                                                                +
                                                            </button>
                                                            <button v-if="index > 0" type="button" @click="deleteItem(index)" class="btn btn- iq-bg-danger btn-sm"><i class="ri-delete-bin-line m-0"></i></button>
                                                        </b-td>
                                                    </b-tr>
                                                </table>
                                            </b-row>
                                            <div class="row">
                                                <div class="col-sm-3"></div>
                                                <div class="col text-right">
                                                    <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>                                                    &nbsp;
                                                    <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                                                </div>
                                            </div>
                                        </b-form>
                                    </ValidationObserver>
                                </b-col>
                            </b-row>
                        </b-overlay>
                    </template>
                </iq-card>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { core } from '../../../../../config/pluginInit'
import RestApi, { trainingElearningServiceBaseUrl } from '@/config/api_config'
import {
  getTrainerApi,
  getCourseSyllabusApi,
  assignCourseTrainerStoreApi,
  assignCourseTrainerUpdateApi,
  circularDataApi
} from '../../api/routes'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
    name: 'FormLayout',
    props: ['id'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    created () {
        if (this.id) {
            this.loader = true
            this.getTrainerList()
            this.getCourseSyllabusList()
            const tmp = this.getData()
            this.formData.fiscal_year_id = tmp.fiscal_year_id
            this.formData.org_id = tmp.org_id
            this.formData.circular_id = tmp.circular_id
            this.formData.training_name_id = tmp.training_name_id
            this.formData.batch_id = tmp.batch_id
            this.formData.trainer_id = tmp.trainer_id
            this.tmpDetails = tmp.details
        }
    },
    mounted () {
        core.index()
    },
    data () {
        return {
            saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            loader: false,
            spinLoader: false,
            trainerSpinLoader: false,
            tmpDetails: [],
            formData: {
                fiscal_year_id: 0,
                org_id: 0,
                circular_id: 0,
                training_name_id: 0,
                batch_id: 0,
                trainer_id: 0,
                details: [{
                    course_id: ''
                }]
            },
            trainingNameList: [],
            courseSyllabusList: [],
            circularMemoList: [],
            batchList: [],
            trainerList: []
        }
    },
    computed: {
        orgList: function () {
            return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0).map(item => {
                if (this.$i18n.locale === 'bn') {
                    return { value: item.value, text: item.text_bn }
                } else {
                    return { value: item.value, text: item.text_en }
                }
            })
        },
        fiscalYearList: function () {
            return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0).map(item => {
                if (this.$i18n.locale === 'bn') {
                    return { value: item.value, text: item.text_bn }
                } else {
                    return { value: item.value, text: item.text_en }
                }
            })
        }
        // batchList: function () {
        //     const obj = this.$store.state.TrainingElearning.commonObj.batchList.filter(item => item.status === 1)
        //     return obj.map((obj, key) => {
        //         if (this.$i18n.locale === 'bn') {
        //             return { value: obj.value, text: obj.text_bn }
        //         } else {
        //             return { value: obj.value, text: obj.text_en }
        //         }
        //     })
        // }
    },
    watch: {
        'formData.fiscal_year_id': function () {
            this.circularMemoList = this.getCircularMemoList()
            this.courseSyllabusList = []
             this.formData.details = [{
              course_id: ''
            }]
          this.formData.circular_id = 0
          this.formData.training_name_id = 0
        },
        'formData.circular_id': function () {
            this.trainingNameList = this.getTrainingNameList()
            this.getTrainerList()
          this.getCircularData()
        },
        'formData.training_name_id': function () {
            this.getTrainerList()
            this.getCourseSyllabusList()
        },
        'formData.batch_id': function () {
            this.getTrainerList()
        }
    },
    methods: {
        addMore (index) {
            this.formData.details.push({
                course_id: ''
            })
            // this.courseSyllabusList.forEach((element, key) => {
            //   if (element.value === this.formData.details[index].course_id.value) {
            //     element.disabled = true
            //   }
            // })
        },
        async getTrainerList () {
            this.trainerSpinLoader = true
            const result = await RestApi.getData(trainingElearningServiceBaseUrl, getTrainerApi, { fiscal_year_id: this.formData.fiscal_year_id, circular_id: this.formData.circular_id, training_name_id: this.formData.training_name_id, batch_id: this.formData.batch_id })
            if (result.success) {
                this.trainerList = result.data.map(item => {
                    return Object.assign({ value: item.get_trainer_name.id, text: this.$i18n.locale === 'en' ? item.get_trainer_name.name : item.get_trainer_name.name_bn })
                })
                this.trainerSpinLoader = false
            } else {
                this.trainerSpinLoader = false
                this.trainerList = []
            }
        },
        getTrainingNameList () {
            const trainingObj = this.$store.state.TrainingElearning.commonObj.circularMemoList.find(item => item.value === this.formData.circular_id)
            return this.$store.state.TrainingElearning.commonObj.trainingNameList.filter(item => item.status === 1 && item.value === trainingObj.training_title_id).map(item => {
                if (this.$i18n.locale === 'bn') {
                    return { value: item.value, text: item.text_bn }
                } else {
                    return { value: item.value, text: item.text_en }
                }
            })
        },
        async getCourseSyllabusList () {
            const result = await RestApi.getData(trainingElearningServiceBaseUrl, getCourseSyllabusApi, { fiscal_year_id: this.formData.fiscal_year_id, training_name_id: this.formData.training_name_id })
            if (result.success) {
                const myArray = []
                result.data.map(item => {
                    const newA = Object.assign({ value: item.id, text: this.$i18n.locale === 'en' ? item.name : item.name_bn })
                    myArray.push(newA)
                })
                this.courseSyllabusList = [...myArray]
                if (this.id) {
                    const newArr = []
                    this.tmpDetails.map(item => {
                        const mData = this.courseSyllabusList.find(el => el.value === item.course_id)
                        if (mData) {
                            newArr.push({ course_id: mData })
                        }
                    })
                    this.formData.details = [...newArr]
                }
            }
            this.loader = false
        },
        getCircularMemoList: function () {
            const obj = this.$store.state.TrainingElearning.commonObj.circularMemoList.filter(item => item.fiscal_year_id === this.formData.fiscal_year_id)
            return obj.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        deleteItem (index) {
            this.formData.details.splice(index, 1)
        },
        async storeUpdate () {
            this.loader = true
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            let result = null
            const loadinState = { loading: false, listReload: true }
            if (this.id) {
                result = await RestApi.putData(trainingElearningServiceBaseUrl, `${assignCourseTrainerUpdateApi}/${this.id}`, this.formData)
            } else {
                result = await RestApi.postData(trainingElearningServiceBaseUrl, assignCourseTrainerStoreApi, this.formData)
            }
            this.$store.dispatch('mutateCommonProperties', loadinState)
            if (result.success) {
                this.loader = false
                this.$store.dispatch('DisabilitySchoolService/mutateCommonObj', { hasDropdownLoaded: false })
                this.$toast.success({
                    title: this.$t('globalTrans.success'),
                    message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                    color: '#D6E09B'
                })
                this.$bvModal.hide('modal-4')
            } else {
                this.loader = false
                this.$refs.form.setErrors(result.message)
                this.$toast.error({
                  title: 'Warning!',
                  message: result.message,
                  color: '#D6E09B'
                })
            }
        },
        getData () {
            const tmpData = this.$store.state.list.find(item => item.id === this.id)
            return JSON.parse(JSON.stringify(tmpData))
        },
        async getCircularData () {
          if (this.formData.fiscal_year_id && this.formData.circular_id) {
            this.moduleSpinLoader = true
            const result = await RestApi.getData(trainingElearningServiceBaseUrl, circularDataApi, { fiscal_year_id: this.formData.fiscal_year_id, circular_id: this.formData.circular_id })
            if (result.success) {
              this.formData.training_name_id = result.training
              this.batchList = result.batch.map((item, index) => {
                if (this.$i18n.locale === 'en') {
                  return Object.assign({}, { value: item.batch_d.id, text: item.batch_d.batch })
                          } else {
                  return Object.assign({}, { value: item.batch_d.id, text: item.batch_d.batch_bn })
                         }
              })
              this.moduleSpinLoader = false
            }
          }
        }
    }
}
</script>
<style scoped>
.overlay {
    position: absolute;
    left: 65%;
    z-index: 9999;
    top: 10px;
    text-align: center;
}
</style>
